// Gender Switch
const preorderCollectionSwitch = document.querySelectorAll('.preorder-products__switch--gender');
const preorderCollectionSlider = document.querySelector('.preorder-products__switch--slider');

// Main functionality
preorderCollectionSwitch.forEach(el => {
  el.addEventListener('click', function () {
    if (el.classList.contains('active')) return;

    // 1) Update active Class
    preorderCollectionSwitch.forEach(btn => btn.classList.remove('active'));
    this.classList.add('active');

    // 2) Update Slider & Products
    const getGender = this.getAttribute('data-gender');
    const mensProducts = document.querySelectorAll('.product-card--men');
    const womensProducts = document.querySelectorAll('.product-card--women');

    if (getGender == 'men') {
      // Update Slider
      preorderCollectionSlider.classList.remove('active-women');
      preorderCollectionSlider.classList.add('active-men');

      // Update Products
      mensProducts.forEach(product => product.classList.remove('hidden'));
      womensProducts.forEach(product => product.classList.add('hidden'));

    } else if (getGender == 'women') {
      // Update Slider
      preorderCollectionSlider.classList.remove('active-men');
      preorderCollectionSlider.classList.add('active-women');

      // Update Products
      mensProducts.forEach(product => product.classList.add('hidden'));
      womensProducts.forEach(product => product.classList.remove('hidden'));
    }
  })
})

// Women's URL
// https://unboundmerino.com/collections/preorder?load=women
document.addEventListener("DOMContentLoaded", function () {
  function hasURLParameter(param, value) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(param)?.toLowerCase() === value;
  }

  if (hasURLParameter("load", "women")) {
    const womenSwitch = document.querySelector(".preorder-products__switch--gender[data-gender='women']");
    if (womenSwitch) womenSwitch.click();
  }

  document.querySelector(".preorder-products").classList.remove("blank");
});